import { readFileSync, writeFileSync, existsSync, mkdirSync } from "node:fs";
import { resolve, dirname } from "node:path";

export type WorkflowPhase = "intake" | "build" | "review" | "done";

export interface WorkflowState {
  phase: WorkflowPhase;
  specPath?: string;
  featuresTotal: number;
  featuresComplete: number;
  totalBudget: number;
  totalSpent: number;
  lastSessionAt?: string;
  buildQueue: string[];
}

/**
 * Read the workflow state from .fathom/workflow.json.
 * Returns null if no state exists.
 */
export function readWorkflowState(): WorkflowState | null {
  const statePath = resolve(process.cwd(), ".fathom", "workflow.json");
  if (!existsSync(statePath)) return null;
  try {
    return JSON.parse(readFileSync(statePath, "utf-8"));
  } catch {
    return null;
  }
}

/**
 * Write or update the workflow state. Always writes to .fathom/.
 */
export function writeWorkflowState(state: WorkflowState): void {
  const statePath = resolve(process.cwd(), ".fathom", "workflow.json");
  mkdirSync(dirname(statePath), { recursive: true });
  writeFileSync(statePath, JSON.stringify(state, null, 2) + "\n");
}

/**
 * Update specific fields in the workflow state.
 * Creates a default state if none exists.
 */
export function updateWorkflowState(
  updates: Partial<WorkflowState>,
): void {
  const existing = readWorkflowState() ?? {
    phase: "intake" as const,
    featuresTotal: 0,
    featuresComplete: 0,
    totalBudget: 0,
    totalSpent: 0,
    buildQueue: [],
  };
  writeWorkflowState({ ...existing, ...updates });
}
